import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=39282109&scoped=true&lang=pug&"
import script from "./HeaderItem.vue?vue&type=script&lang=js&"
export * from "./HeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&id=39282109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39282109",
  null
  
)

export default component.exports